import { render, staticRenderFns } from "./ConfirmCancelacionPolizaDialog.vue?vue&type=template&id=63393432&"
import script from "./ConfirmCancelacionPolizaDialog.vue?vue&type=script&lang=js&"
export * from "./ConfirmCancelacionPolizaDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports